import React, { useState, useEffect } from 'react';
import ChatPage from './Chat/ChatPage';
import { X } from 'lucide-react';
import { useChatContext } from './context/SignamRContext';
import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_CHAT_PROD;

const WA_GREEN = '#ff8f28';

export default function ChatWidget({ brojPoruka, setBrojPoruka }) {
  const [isOpen, setIsOpen] = useState(false);
  const { unreadedMessages } = useChatContext();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setIsOpen(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const vratiBrNeProcitanihPoruka = async () => {
    const userId = +localStorage.idKorisnika;
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Messages/chat_vrati_broj_poruka_koje_nisu_procitane`,
        userId,
        {
          headers: {
            'Content-Type': 'application/json', // Postavljanje odgovarajućeg Content-Type zaglavlja
          },
        },
      );
      if (response.status === 200)
        setBrojPoruka(response.data.brojNeProcitanihPoruka);
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };

  useEffect(() => {
    console.log('brojPoruka', brojPoruka);
  }, [brojPoruka]);
  useEffect(() => {
    setIsOpen(true);
    vratiBrNeProcitanihPoruka();
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 100); // 1000ms = 1s

    return () => clearTimeout(timer); // cleanup kad se komponenta unmountuje
  }, []);

  return (
    <div
      style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1300 }}
    >
      {isOpen ? (
        <div
          style={{
            width: '480px',
            background: 'white',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            fontFamily: 'Roboto, sans-serif',
            minHeight: '70vh',
          }}
        >
          {/* Header */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 15px',
              background: WA_GREEN,
              color: 'white',
              fontWeight: '500',
            }}
          >
            <span>Chat</span>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                fontSize: '20px',
              }}
            >
              <X size={22} />
            </button>
          </div>

          {/* Chat sadržaj */}
          <div style={{ flex: 1, background: '#ECE5DD' }}>
            <ChatPage brojPoruka={brojPoruka} setBrojPoruka={setBrojPoruka} />
          </div>
        </div>
      ) : (
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setIsOpen(true)}
            style={{
              background: WA_GREEN,
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              cursor: 'pointer',
              fontSize: '30px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
              position: 'relative',
            }}
          >
            💬
          </button>

          <span
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              background: 'red',
              color: 'white',
              borderRadius: '50%',
              padding: '4px 8px',
              fontSize: '12px',
              fontWeight: 'bold',
              boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
            }}
          >
            {brojPoruka}
          </span>
        </div>
      )}
    </div>
  );
}
